"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSViewSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const calendar_settings_context_1 = require("../../../calendar-settings-context");
const CSViewSection = () => {
    const { control } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const calendarRowTemplatesController = (0, react_hook_form_1.useController)({
        control,
        name: 'calendarRowTemplates',
    });
    const calendarRowUnassignedController = (0, react_hook_form_1.useController)({
        control,
        name: 'calendarRowUnassigned',
    });
    const calendarRowOffersController = (0, react_hook_form_1.useController)({
        control,
        name: 'calendarRowOffers',
    });
    const calendarShowStatisticsController = (0, react_hook_form_1.useController)({
        control,
        name: 'calendarShowStatistics',
    });
    const calendarShowCapacitiesController = (0, react_hook_form_1.useController)({
        control,
        name: 'calendarShowCapacities',
    });
    return (react_1.default.createElement("div", { style: { padding: '0.75rem' } },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    paddingBottom: '0.5rem',
                } },
                react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('CALENDAR_ROWS')),
                react_1.default.createElement(ui_1.Checkbox, { checked: calendarRowTemplatesController.field.value, onChange: (v) => calendarRowTemplatesController.field.onChange(v) },
                    react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE }, (0, util_1.t)('CALENDAR_ROWS_TEMPLATES'))),
                react_1.default.createElement(ui_1.Checkbox, { checked: calendarRowUnassignedController.field.value, onChange: (v) => calendarRowUnassignedController.field.onChange(v) },
                    react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE }, (0, util_1.t)('CALENDAR_ROWS_UNASSIGNED'))),
                isPluginEnabled('offers') ? (react_1.default.createElement(ui_1.Checkbox, { checked: calendarRowOffersController.field.value, onChange: (v) => calendarRowOffersController.field.onChange(v) },
                    react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE }, (0, util_1.t)('CALENDAR_ROWS_OFFERS')))) : null),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    paddingBottom: '0.5rem',
                } },
                react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('STATS_CAPACITIES')),
                react_1.default.createElement(ui_1.RadioGroup, { direction: ui_1.RadioGroup.DIRECTIONS.VERTICAL, value: calendarShowStatisticsController.field.value.toString() +
                        '_' +
                        calendarShowCapacitiesController.field.value.toString(), onChange: (v) => {
                        const vals = v.split('_').map((val) => val === 'true');
                        calendarShowStatisticsController.field.onChange(vals[0]);
                        calendarShowCapacitiesController.field.onChange(vals[1]);
                    }, options: [
                        {
                            value: Boolean(false).toString() + '_' + Boolean(false).toString(),
                            label: (0, util_1.t)('STATS_CAPACITIES_OFF'),
                        },
                        {
                            value: Boolean(true).toString() + '_' + Boolean(false).toString(),
                            label: (0, util_1.t)('STATISTICS'),
                        },
                        {
                            disabled: !isPluginEnabled('capacityplanning'),
                            value: Boolean(false).toString() + '_' + Boolean(true).toString(),
                            label: (0, util_1.t)('CAPACITY'),
                        },
                    ].filter(Boolean) })))));
};
exports.CSViewSection = CSViewSection;
